<template>
	<div class="double-box">
		<div v-title>评价备注</div>
		<div class="remark-box">
      <div class="review">
        您对本次服务的评价是 : <span>{{score | forscore}}</span>
      </div>
      <div class="remark-text">
        <textarea placeholder="您可填写评价备注，最多200字（选填）" @input="changeCont"  v-model="content" maxlength="200"></textarea>
      </div>
      <div class="submit-box">
        <div :class="{'submit':true,'submit-gray':!canSend,'submit-check':canSend}" @click="present"  >提交</div>
      </div>
    </div>
	</div>
</template>

<script>
	export default{
		data(){
			return{
        reviewType : '',
        content : '',
        canSend : false,
        uid : '',
        convId : '',
        score : ''
			}
		},
    created() {
      if(this.$route.query.uid){
        this.uid = this.$route.query.uid
      }
      if(this.$route.query.convId){
        this.convId = this.$route.query.convId
      }
      if(this.$route.query.score){
        this.score = this.$route.query.score
      }
    },
    methods:{
      present(){
        if(this.content == ""){
          return false
        }
        this.canSend = false
        let formData = new FormData()
        formData.append('uid',this.uid)
        formData.append('content',this.content)
        formData.append('convId',this.convId)
        this.http({
        	url: 'http://chat.ce.reflower.com.cn/chat/client/comment',
        	method: 'post',
        	data: formData
        }).then(res => {
        	this.canSend = true;
        	if(res.data.code == 1) {
            this.popUp('提交成功！')
            setTimeout(function() {
              //这个可以关闭安卓系统的手机
               document.addEventListener(
                  "WeixinJSBridgeReady",
                  function() {
                     WeixinJSBridge.call("closeWindow");
                  },
                 false
               );
                //这个可以关闭ios系统的手机
               WeixinJSBridge.call("closeWindow");
            })
        	} else {
            this.canSend = true;
        		this.popUp(res.data.msg)
        	}

        })
      },
      changeCont(){
        if(this.content.length>0){
          this.canSend = true
        }else{
          this.canSend = false
        }
      },
      //tost
      popUp: function(content) {
      	layer.open({
      		content: content,
      		skin: 'msg',
      		time: 2 //2秒后自动关闭
      	});
      },

    },
    filters:{
      forscore(val){
        if(val==1){
          return "一般"
        }else if(val == 2){
          return "满意"
        }else if(val == 3){
          return "非常满意"
        }
      }
    }
	}
</script>

<style scoped>
	.double-box{
		height: 100vh;
		background-color: #FFFFFF;
    /* padding: 0 0.4rem; */
    background: url(https://misc.reflower.com.cn/images/order/logo-text.png) no-repeat center center;
    background-size: 100%;
	}
  .remark-box{
  }
  .review{
    padding:0.666666rem 0.4rem;
    font-size: 0.4rem;
    text-align: left;
    background-color: #FFFFFF;
  }
  .review span{
    color: #b22222;
    font-weight: 500;
  }
  .remark-text{
    background-color: #FFFFFF;
    padding: 0.4rem 0.4rem;
  }
  .remark-text textarea {
		display: inline-block;
		resize: none;
		border: none;
		outline: none;
		width: 100%;
		font-size: 0.373333rem;
		height: 2.933333rem;
		line-height: 0.533333rem;
    border: 1px solid #DDDDDD;
    padding: 0.2rem 0.2rem;
	}
  .submit-box{
    padding: 0.4rem 0.4rem;
  }
  .submit {
  	width: 100%;
  	height: 1.306666rem;
  	line-height: 1.306666rem;
  	font-size: 0.48rem;
  	color: #FFFFFF;
    border-radius: 0.053333rem;

  }
  .submit-gray{
    background-color: #DDDDDD;
  }
  .submit-check{
    background-color: #C4D275;
  }
</style>



// WEBPACK FOOTER //
// src/path/submenu/chatremark.vue